var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 15,
    viewBox: "0 0 42 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6061 6.6028H70V9.29438H68.6061V6.6028ZM1.70066 7.94859L0.558239 8.71963L0 7.94859L0.558239 7.17755L1.70066 7.94859ZM68.6061 9.29438H1.70066V6.6028H68.6061V9.29438ZM0.558239 7.17755L5.75478 0L8.03962 1.54208L2.84308 8.71963L0.558239 7.17755ZM2.84308 7.17755L7.39005 13.4579L5.10522 15L0.558239 8.71963L2.84308 7.17755Z",
    fill: "#2F57BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLeft);
export default __webpack_public_path__ + "static/media/sliderLeft.8e7c3f2d75ef45f382f0597533a60ef4.svg";
export { ForwardRef as ReactComponent };